import { render, staticRenderFns } from "./ComplaintLocationCard.vue?vue&type=template&id=ab2ad6d4"
import script from "./ComplaintLocationCard.vue?vue&type=script&lang=ts"
export * from "./ComplaintLocationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports